import { z } from 'zod';

import { defineEndpoint } from './endpoint';
import { Persona } from './identidade';

export const Me = z.object({
  id: z.uuid(),
  email: z.string(),
  nome: z.string().nullable(),
  persona: Persona,
  /** Só para exibição; a UI decide por `persona`. */
  roleName: z.string(),
  parceiroId: z.uuid().nullable(),
  eletropostoNavVisible: z.boolean(),
  /** Escolhe em nome de quem a venda sai (parceiro ou Aliança): `vendas.escolher-titular`. */
  podeEscolherTitular: z.boolean(),
  /** Registra e reverte o pagamento de comissão: `comissoes.desembolso.*`. */
  podePagarComissao: z.boolean(),
  /** Vê o ranking de consultores no Início: `relatorios.associados.ranking`. */
  podeVerRanking: z.boolean(),
  /** Vê o ranking de parceiros no Início: `relatorios.associados.ranking-parceiros`. */
  podeVerRankingParceiros: z.boolean(),
  /** Tem carteira de parceiros (o filtro "Minha carteira"): `PERSONAS_COM_CARTEIRA`. */
  temCarteira: z.boolean(),
  /** Atribui, transfere e remove parceiros das carteiras (as abas "Carteiras" e "Atribuir"): `parceiros.carteira.definir`. */
  podeDistribuirCarteira: z.boolean(),
  needsRegistration: z.boolean(),
  /** Pessoa de parceiro ainda nas boas-vindas: a tela leva a `/boas-vindas` (ONBOARDING §5.3). */
  emOnboarding: z.boolean(),
  /** Banner de impersonação (T02 §3.10): admin e início da impersonação ativa, ou `null`. */
  impersonation: z.object({ adminNome: z.string().nullable(), iniciadaEm: z.string() }).nullable(),
});
export type Me = z.infer<typeof Me>;

/** Substitui `get_current_user_info` no caminho quente (R-6). Contadores: `GET /api/me/badges` (dom-identidade). */
export const lerMe = defineEndpoint({ method: 'GET', path: '/api/me', output: Me });
